import { SyncOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 12px;
  background: rgba(222, 237, 255, 1);
  padding: 16px;
  border-radius: 16px;

  @media screen and (max-width: 400px) {
    gap: 8px;
  }
`;

export const WalletContainer = styled.div`
  display: flex;
  height: 70px !important;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 12px;
  background: linear-gradient(180deg, #0294F0 0%, #0274BC 100%);
  box-shadow: 0px 3px 8px 0px #00000033;
  flex: 0.6;
  padding-top: 3px;

  @media screen and (max-width: 400px) {
    gap: 4px;
  }

  @media screen and (max-width: 390px) {
    svg {
      width: 20px;
    }
  }
`;

export const WalletDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 70px !important;
`;

export const WalletTitle = styled.div`
  color: rgba(255, 206, 0, 1);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TopUpAndWithDrawContainer = styled.div`
  flex: 0.9;
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: space-between;
`;

export const ActionButton = styled.div`
  display: flex;
  height: 70px;
  width: 70px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  flex: 1;
  border-radius: 12px;
  background: linear-gradient(180deg, #0294F0 0%, #0274BC 100%);
  box-shadow: 0px 3px 8px 0px #00000033;
  padding-top: 3px;
  gap: 5px;

  @media screen and (max-width: 390px) {
      svg {
          width: 20px;
      }
  }
`;

export const Text = styled.div`
  color: #FFF;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media screen and (max-width: 340px) {
    font-size: 10px;
  }
`;

export const BalanceText = styled(Text)`
  color: #ffffff;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media screen and (max-width: 390px) {
    font-size: 12px;
  }

  @media screen and (max-width: 340px) {
    font-size: 10px;
  }
`;

export const ReloadIcon = styled(SyncOutlined)`
color: rgba(255, 206, 0, 1);
font-size: 16px;
margin-bottom: 5px;
`;